import React, {useState} from 'react';
import { Link, Navigate } from "react-router-dom";
import LoginBg from '../images/lnb-logo.jpeg';
import axiosInstances from '../components/axiosInstance';

const Login =()=>{

    const [msisdn, setMsisdn] = useState(''); 
    const [pin, setPin] = useState(''); 
    //const [sub, setSub] = useState(false)
    const [redirect, setRedirect] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const submit = async (e) =>{
        e.preventDefault();

        
        const {data} = await axiosInstances.write.post('login',{
            msisdn, 
            pin,
        });
      //  console.log(data.headers)
        
        const responseCode = data.response_code
        if(responseCode === "60042"){
            setErrorMessage(data.message);
            //setSub(false);
        }
        
        if(responseCode === "0"){
            //setSub(true);
           // console.log("Is a subscriber sub:" + sub)
            setRedirect(true);
        }
        
       console.log(data);
        
    }
    const passableParams = {
        msisdn
    }


     
    if(redirect){
        return <Navigate to={'/'}  replace={true}  state={ passableParams } />;
    }
   
    return (
        <>
        <form onSubmit={submit}>
        <div className="bg-gray-100 flex justify-center items-center h-screen">
      
        <div className="bg-white p-8 rounded shadow-md w-80">
    <h2 className="text-2xl font-semibold mb-4">MimiNiSisi</h2>
    
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700">Phone Number</label>
        <input
        type="number"
        pattern="[0-9]*"
        placeholder='Phone Number'  className="mt-1 p-2 w-full border rounded-md"
        onChange={e => setMsisdn(e.target.value) }
        />
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700">PIN</label>
        <input type="password" placeholder='PIN'  className="mt-1 p-2 w-full border rounded-md"
        onChange={e => setPin(e.target.value) }
        />
      </div>

      <button type="submit" className="w-full bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
      onClick={submit}
      >
        Login
    </button>

      <hr className="my-8" />
                {errorMessage}
                <p className="mt-4">
                    <Link
                    className="text-sm font-medium text-purple-600 dark:text-purple-400 hover:underline"
                    to={"/subscribe"}
                    >
                    Subscribe
                    </Link>
                </p>
     
  </div>
          
           
        
    </div>
        </form>
         
        </>
    );
}

export default Login;